import { useForm } from 'react-hook-form';
import Button from '../../components/button';
import DatepickerDefault from '../../components/daterangePicker';
import FormHead from '../../components/headings/FromHead';
import Modal from '../../components/modal'
import { getMilliSecUTC } from '../../utils/EllowUtils';

export type IncontractFilterForm = {
    contractDuration ?: any
}

interface props {
    onClose?: any;
    clickHandler?: any;
}

const IncontractFilter = (props: props) => {

    const formOptions = {
    //    resolver: yupResolver(validationSchema),
  };
  

      const {
        handleSubmit,
        setValue,
      } = useForm<IncontractFilterForm>(formOptions);
    

  const handleChange = (event: any, name: string) => {
      
    if (name === "contractDuration") {
      let duration = {
        "startDateFrom": getMilliSecUTC(event.target.value.start),
        "startDateTo": getMilliSecUTC(event.target.value.end),
        "endDateFrom": getMilliSecUTC(event.target.value.start),
        "endDateTo": getMilliSecUTC(event.target.value.end)
      }
      setValue("contractDuration", duration);
    }
       
    }
    
    const onSubmit = (data: any) => {
              
      props.clickHandler(data)
      
    }

  return (
      <Modal title={'IncontractFilter'} size='small' onClose={props.onClose}>
          <form>
      <FormHead>Filters</FormHead>
      <div className="form-group mb-40">
          <label className="lablel">Contract Duration</label>
              <DatepickerDefault
            onChange={(e: any) => handleChange(e, "contractDuration")}
          />
              </div>
              <div className="popupAction">
          <Button
            onClick={props.onClose}
            type="submit"
            variant="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit(onSubmit)}
            type="submit"
            variant="primary"
            size="small"
          >
            Submit
          </Button>
        </div>
              </form>

    </Modal>
  )
}

export default IncontractFilter